import { Separator } from "@/components/ui/separator";

import { ClaimBusinessIcon, DashboardIcon, ExploreBusinessIcon } from "./icons";
import Menu, { MenuItem, type MenuProps } from "./menu";

interface BusinessMenuProps extends Omit<MenuProps, "children" | "label"> {}

export default function BusinessMenu(props: BusinessMenuProps) {
  return (
    <Menu label="Morty for Business" {...props}>
      <MenuItem
        href="https://link.morty.app/e/claim-your-business"
        icon={<ClaimBusinessIcon />}
        isExternal
      >
        Claim your business
      </MenuItem>
      <MenuItem
        href="https://biz.morty.app/"
        icon={<DashboardIcon />}
        isExternal
      >
        Log in to Business account
      </MenuItem>
      <Separator className="bg-white/10" orientation="horizontal" />
      <MenuItem
        href="/s/morty-for-business"
        icon={<ExploreBusinessIcon />}
        isExternal
      >
        Explore Morty for Business
      </MenuItem>
    </Menu>
  );
}
